import { DESCENDING_STATS } from '../composables/useCoachData.js';

// The coach UI's one list of "lower is better". It drives match-table cell coloring
// AND, via isWorseWhenHigher, breakdown peer deltas, so the two cannot disagree.
// Supersets Rails' DESCENDING_STAT_COLUMNS, which omits opening_fails.
export const worseWhenHigherStats = [
  'crosshair_placement_average', 'deaths', 'initial_crosshair_placement_average',
  'opening_fails', 'time_to_damage_average', 'time_to_kill_average',
  'trade_kill_fails', 'traded_death_fails', 'util_flash_friends_flashed',
  'util_flash_total_friend_duration', 'util_he_friend_damage', 'util_lost_cost',
];

// Belt and braces: anything Rails calls descending counts too, in case the list
// above ever falls behind it.
const WORSE_WHEN_HIGHER = new Set([...DESCENDING_STATS, ...worseWhenHigherStats]);

// The coloring list wins outright for the keys it names — otherwise the profile
// payload's is_ascending (which mirrors Rails, and Rails omits opening_fails)
// makes the popover contradict the cell beside it. Then is_ascending, then the union.
export function isWorseWhenHigher(key, entry) {
  if (worseWhenHigherStats.includes(key)) return true;
  if (entry && typeof entry === 'object' && typeof entry.is_ascending === 'boolean') {
    return !entry.is_ascending;
  }
  return WORSE_WHEN_HIGHER.has(key);
}
